module.exports = __webpack_public_path__ + "img/VW.adaed0c.jpg";